var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3418 0H2.65968C1.19088 0 0 1.15488 0 2.57904V33.4195C0 34.8451 1.19088 36 2.65968 36H33.3418C34.8106 36 36 34.8437 36 33.4195V2.57904C36 1.15488 34.8106 0 33.3418 0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1054 21.4897C23.9092 21.4897 22.7896 20.9828 21.7709 20.1574L22.0189 18.9928L22.0298 18.9502C22.2511 17.7103 22.9513 15.6279 25.1054 15.6279C26.721 15.6279 28.0351 16.9444 28.0351 18.5612C28.0302 20.1732 26.7161 21.4897 25.1054 21.4897ZM25.1054 12.6557C22.3532 12.6557 20.2198 14.4463 19.353 17.3906C18.028 15.4006 17.0263 13.0119 16.4391 11H13.4779V18.7168C13.4779 20.2376 12.2391 21.4775 10.7196 21.4775C9.20005 21.4775 7.96253 20.2376 7.96253 18.7168V11H5.00003V18.7168C4.98909 21.8775 7.55894 24.4716 10.7147 24.4716C13.8705 24.4716 16.4404 21.8775 16.4404 18.7168V17.4222C17.0166 18.6245 17.7216 19.8377 18.5787 20.9171L16.7637 29.4594H19.7967L21.1108 23.2633C22.2632 24.0024 23.5883 24.4656 25.1078 24.4656C28.356 24.4656 31 21.8009 31 18.5491C30.9976 15.3033 28.3536 12.6557 25.1054 12.6557Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.c867175ad9e9c1d5a1bb1d2bd7e6d2d9.svg";
export { ForwardRef as ReactComponent };